const dev = {
    baseURL: "http://localhost:8888/team",
};

const prod = {
    baseURL: "https://api.team.mcqslearn.com",
};

export default process.env.NODE_ENV === "production" ? prod : dev;